import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../../common/api/http.service";
import { ExportApi } from "./export.api";

@Injectable()
export class PaymentsApi {
  private readonly apiController: string = "payment";

  constructor(private api: HttpService, private exportApi: ExportApi) {}

  getTopUpConfig(): Observable<string> {
    return this.api.get(`${this.apiController}/topup/key`, { responseType: "text" });
  }

  removeAutomatedTopUp(): Observable<any> {
    return this.api.delete(`${this.apiController}/auto-enabled`);
  }

  getAutomatedTopUp(): Observable<any> {
    return this.api.get(`${this.apiController}/auto-enabled`);
  }

  topUp(topUp: any): any {
    return this.api.post(`${this.apiController}/topup/initialise`, topUp);
  }

  getIntentStatus(intentId: string): Observable<any> {
    return this.api.get(`${this.apiController}/topup/${intentId}/status`);
  }

  getTopUpSetupIntentStatus(intentId: string): Observable<any> {
    return this.api.get(`${this.apiController}/topup/card/${intentId}/status`);
  }

  getPayments(startDate: Date, endDate: Date): any {
    return this.api.get(
      `${
        this.apiController
      }?startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}`
    );
  }

  exportPayments(startDate: Date, endDate: Date): Observable<any> {
    return this.exportApi.get(
      `${
        this.apiController
      }/export?startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}`
    );
  }

  getPaymentCards(): Observable<any> {
    return this.api.get(`${this.apiController}/cards`);
  }

  removePaymentCard(cardId: number): Observable<any> {
    return this.api.delete(`${this.apiController}/cards/${cardId}`);
  }

  getPaymentCard(cardId: number): Observable<any> {
    return this.api.get(`${this.apiController}/cards/${cardId}`);
  }

  addCard(card: any) {
    return this.api.post(`${this.apiController}/cards`, card);
  }

  updatePaymentCard(request: any): Observable<any> {
    return this.api.put(`${this.apiController}/cards`, request);
  }

  calculateNetAndVat(grossAmount: number): Observable<any> {
    return this.api.post(
      `${this.apiController}/net-vat/calculate`,
      grossAmount
    );
  }

  downloadReceipt(id: number, franchiseCode: string): Observable<any> {
    return this.api.get(
      `${this.apiController}/receipt/${franchiseCode}/${id}`,
      { responseType: "blob" }
    );
  }
}
